import request from 'superagent'

export default class GetApi{
  constructor({ skipReload = false } = {}) {
    this.skipReload = skipReload
  }

  getCSRFtoken(){
    let token
    if (document.querySelector('meta[name="csrf-token"]') ){
      token = document.querySelector('meta[name="csrf-token"]').content
    }
    return token
  }

  execute(url, params, successCallback = () => {}, errCallback = () => {}){
    return new Promise((resolve, reject) => {
      request.get(url)
        .query(params)
        .set('X-CSRF-Token', this.getCSRFtoken())
        .set('Accept', 'application/json')
        .end((err, res) => {
          if (res && (res.statusCode == 401 || res.statusCode == 422)) {
            this.skipReload || location.reload()
          }
          if (err) {
            errCallback(res)
            reject(res)
          }else{
            successCallback(res)
            resolve(res)
          }
        })
    })
  }

  executePromise(url, params) {
    return new Promise((resolve, reject) => this.execute(url, params, resolve, reject))
  }
}
